import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Hierarchical slide structure for Cineself presentation
    slides: [
      {
        id: 'welcome',
        path: '/',
        title: 'Welcome',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'the-barrier',
        path: '/the-barrier',
        title: 'The barrier',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'opportunity',
        path: '/opportunity',
        title: 'Opportunity',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'vision',
        path: '/vision',
        title: 'Vision',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'technology',
        path: '/technology',
        title: 'Technology',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'cineself-suite',
        path: '/cineself-suite',
        title: 'Cineself Suite',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg',
        children: [
          {
            id: 'cineself-suite-casting',
            path: '/cineself-suite/casting',
            title: 'Casting',
            thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
          },
          {
            id: 'cineself-suite-productions',
            path: '/cineself-suite/productions',
            title: 'Productions',
            thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
          },
          {
            id: 'cineself-suite-stream',
            path: '/cineself-suite/stream',
            title: 'Stream',
            thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
          },
        ]
      },
      {
        id: 'the-process',
        path: '/the-process',
        title: 'The Process',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'moenetization',
        path: '/moenetization',
        title: 'Monetization',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg',
      },
      {
        id: 'team',
        path: '/team',
        title: 'Team',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg',
        children: [
          {
            id: 'team-victor',
            path: '/team/victor',
            title: 'Victor',
            thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
          },
          {
            id: 'team-phil',
            path: '/team/phil',
            title: 'Phil',
            thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
          },
          {
            id: 'team-philip',
            path: '/team/Philip',
            title: 'Philip',
            thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
          }
        ]
      },
      {
        id: 'advantages',
        path: '/advantages',
        title: 'Advantages',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },

      {
        id: 'the-ask',
        path: '/ask',
        title: 'The ask',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      },
      {
        id: 'thank-you',
        path: '/thank-you',
        title: 'End',
        thumbnail: '/img/thumbs/HG-slide_placeholder_01-80.jpg'
      }
    ]
  },
  getters: {
    allSlides: state => state.slides
  },
  mutations: {
    reorderSlides(state, newOrder) {
      state.slides = newOrder
    },
    renameSlide(state, { id, title }) {
      const slide = state.slides.find(s => s.id === id)
      if (slide) slide.title = title
    }
  },
  actions: {}
})
